import * as React from 'react';
import BalanceSheetCoreWrapper from '../AfrCore/BalanceSheetCoreWrapper';




const BalanceSheetA = (props: any) => {

    return (
        <React.Fragment>
            <BalanceSheetCoreWrapper userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default BalanceSheetA;